import { FC, useState } from 'react';
import { Chart } from 'react-google-charts';
import styled from 'styled-components';

import { MAPS_API_KEY, REGIONS_OPTIONS, STARTING_REGION } from 'constants/googleMaps';
import { BasicSelect } from 'ui/selects';
import { spacing } from 'ui/theme';

import { InsightPanel } from '../insightPanel/InsightPanel';
import { useProfileQueryContext } from '../../../contexts/demographicInsights';
import { useTranslation } from '../../../hooks';
import { AudienceCount } from '../../../types';

const MapWrapper = styled.div`
  padding: 0 ${spacing.base};
`;

const SelectWrapper = styled.div`
  width: ${spacing.x24};
  margin-bottom: ${spacing.base};
  margin-left: -${spacing.base};
`;

export const LocationsMap: FC = () => {
  const { t } = useTranslation();
  const { locations } = useProfileQueryContext();
  const [region, setRegion] = useState(STARTING_REGION);
  const values = locations ?? [];

  const convertCountsToMapData = (loc: AudienceCount[]) => {
    const header = [
      [
        t('insights.demographics.chartLabels.city'),
        t('insights.demographics.chartLabels.activity'),
        { role: 'tooltip', type: 'string' },
      ],
    ];

    return header.concat(
      loc.map((location) => [location.name, `${location.count}`, location.name]),
    );
  };

  return (
    <InsightPanel title={t('insights.locations')}>
      <MapWrapper data-test="locations-map">
        <SelectWrapper>
          <BasicSelect
            onSelect={setRegion}
            defaultValues={region}
            placeholder="Select a location..."
            id="location-region"
            options={REGIONS_OPTIONS}
            title="location"
          />
        </SelectWrapper>
        <Chart
          width="100%"
          height="auto"
          chartType="GeoChart"
          data={convertCountsToMapData(values)}
          options={{
            region: region[0],
            displayMode: 'markers',
            colors: ['#3498db', '#e74c3c'],
          }}
          mapsApiKey={MAPS_API_KEY}
        />
      </MapWrapper>
    </InsightPanel>
  );
};
